import { defineStyle } from '@chakra-ui/react';

import { switchHelpers } from './utils';

export const switchTheme = switchHelpers.defineMultiStyleConfig({
  baseStyle: switchHelpers.definePartsStyle({
    container: defineStyle({
      fontSize: 'sm',
      display: 'inline-flex',
      alignItems: 'center',
    }),
  }),
});
